import InputField from '../../../components/Forms/Input/InputField';
import {
  mapGeneralSettings,
  toGeneralUpdateDTO,
} from './RestaurantSettingsMapper';
import RestaurantSettingsFormLayout from './RestaurantSettingsFormLayout';
import RestaurantSettingsToggle from './RestaurantSettingsToggle';
import RestaurantFormHelp from '../shared/RestaurantFormHelp';
import useRestaurantSettingsForm from './useRestaurantSettingsForm';

interface Props {
  branchId: number;
}

const RestaurantGeneralSettingsForm = ({ branchId }: Props) => {
  const settings = useRestaurantSettingsForm(
    branchId,
    'general',
    mapGeneralSettings,
    toGeneralUpdateDTO
  );
  const { form, updateField } = settings;

  return (
    <RestaurantSettingsFormLayout
      title="Configuración general"
      description="Comportamiento principal del restaurante y tiempos predeterminados."
      loading={settings.loading}
      saving={settings.saving}
      hasData={Boolean(form)}
      alert={settings.alert}
      onCloseAlert={() => settings.setAlert(null)}
      onSave={settings.save}
      onRetry={settings.reload}
      help={<RestaurantFormHelp topic="settingsGeneral" variant="inline" />}
    >
      {form && (
        <>
          <RestaurantSettingsToggle
            label="Restaurante habilitado"
            description="Habilita la operación del módulo Restaurante en esta sucursal."
            name="restaurant-enabled"
            checked={form.enabled}
            onChange={() => updateField('enabled', !form.enabled)}
          />
          <RestaurantSettingsToggle
            label="Permitir múltiples meseros"
            description="Permite que más de un mesero gestione la misma orden."
            name="multiple-waiters"
            checked={form.multipleWaitersPerOrder}
            onChange={() =>
              updateField('multipleWaitersPerOrder', !form.multipleWaitersPerOrder)
            }
          />
          <RestaurantSettingsToggle
            label="Cerrar orden automáticamente"
            description="Cierra la orden cuando se completa el flujo de cobro."
            name="automatic-close-order"
            checked={form.automaticCloseOrder}
            onChange={() =>
              updateField('automaticCloseOrder', !form.automaticCloseOrder)
            }
          />
          <InputField
            label="Tiempo de preparación por defecto (minutos)"
            iconKey='timer'
            name="defaultPreparationMinutes"
            type="number"
            min={1}
            max={1440}
            value={form.defaultPreparationMinutes}
            onChange={(event) =>
              updateField('defaultPreparationMinutes', Number(event.target.value))
            }
          />
          <p className="-mt-2 text-xs leading-5 text-bodydark2 dark:text-bodydark">
            Se usa en cocina cuando un ítem de menú no tiene su propio tiempo de
            preparación (ni el estimado de su estación).
          </p>
        </>
      )}
    </RestaurantSettingsFormLayout>
  );
};

export default RestaurantGeneralSettingsForm;

